import config from '../config/index';
import { request } from './api';

export default {
  getDealerLicense(dealerId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/license',
      data: { dealerId: dealerId },
    });
  },
  getSpecListByDealerId(dealerId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/specList',
      data: { dealerId: dealerId },
    });
  },
  getPageInfo({ dealerId, source, floor }) {
    return request({
      type: 'get',
      dataType: 'json',
      crossDomain: true,
      url: config.dealerCloudVrapi + '/vrapi/dealer/pageInfo',
      data: { dealerId, source, floor },
    });
  },
  getFunctionData({ dealerId, is4d, salesId = 0 }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/functionData',
      crossDomain: true,
      xhrFields: { withCredentials: true },
      data: {
        dealerId,
        is4d,
        adviserId: salesId,
      },
    });
  },
  getImInfo({ dealerId, bsnsId, userId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/imInfo',
      crossDomain: true,
      xhrFields: { withCredentials: true },
      data: {
        dealerId,
        bsnsId,
        userId,
      },
    });
  },
  /**
   *  http://doc.phonebus.corpautohome.com/project/302/interface/api/33411
   * @param {*} dealerId 经销商id
   * @param {*} seriesId 车系id
   * @returns
   */
  getSeriesInfoByDealerIdAndSeriesId(dealerId, seriesId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudArVr + '/v2/dealerapi/series/special/price/max',
      data: {
        _appId: 'dearler.vr',
        dealerId,
        seriesId,
        needPromotionCondition: 1,
      },
      transformResponse: function (res) {
        if (res.returncode === 0) {
          return res;
        } else {
          Promise.reject(res);
        }
      },
    });
  },

  /**
   * 获取锚点列表
   * 接口地址 http://doc.phonebus.corpautohome.com/project/302/interface/api/37247
   * @param {
   * sceneId： 场景id
   * dealerId: 经销商id
   * cityId: 城市id
   * } param0
   * @returns
   */
  getAnchorList({ dealerId, sceneId, cityId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudVrapi + '/vrapi/dealer/anchor/list',
      crossDomain: true,
      data: {
        dealerId,
        cityId,
        sceneId,
        _appId: 'dearler.vr',
      },
    });
  },
  /**
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/52296
   * @param {*} param0
   * @returns
   */
  getTourList({ dealerId, sceneId }) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudArVr + '/vr4d/guide-image/list',
      crossDomain: true,
      data: {
        dealerId,
        sceneId,
        _appId: 'dearler.vr',
      },
    });
  },
  /**
   * vr带看-呼叫中挂断挽回弹层最大金额红包
   * http://doc.phonebus.corpautohome.com/project/302/interface/api/47678
   * @returns
   */
  getMaxAmountCoupon(dealerId) {
    return request({
      type: 'get',
      dataType: 'json',
      url: config.dealerCloudArVr + '/aractivity/maxAmountCoupon',
      data: { _appId: 'dearler.vr', dealerId },
      contentType: 'application/json;charset=utf-8',
    });
  },
};
